export default {
  'home.announcement': 'Recurso informativo independiente — no afiliado ni respaldado por USFans.',
  'home.heroTitle': 'La forma más inteligente de explorar USFans Spreadsheet',
  'home.heroSub': 'Descubre hallazgos útiles, compara categorías, entiende el control de calidad (QC), revisa los detalles de envío y aprende a investigar productos antes de hacer un pedido.',
  'home.primaryCta': 'USFans Spreadsheet',
  'home.secondaryCta': 'Leer la guía',
  'home.trustLine': 'Investigación independiente · Guías actualizadas · Información centrada en la seguridad',

  'home.categoriesTitle': 'Explora las categorías de USFans Spreadsheet',
  'home.categoriesSub': 'Salta directo a una categoría y navega por los últimos hallazgos en el sitio principal.',
  'home.categoryDropdownLabel': 'Elige una categoría',

  'home.whatTitle': '¿Qué es USFans Spreadsheet?',
  'home.whatP1': 'USFans Spreadsheet es un recurso de investigación compartido que muchas personas usan para organizar enlaces de productos, categorías, notas de vendedores, detalles de QC y referencias de compra en un solo lugar. En lugar de navegar por páginas dispersas, los usuarios recurren a la hoja para explorar artículos de forma más eficiente y comparar opciones antes de decidir.',
  'home.whatP2': 'Es importante dejar claro lo que la hoja no es. No es un mercado oficial y no la gestiona la propia marca. Piensa en ella como un directorio y un sistema de notas creado por la comunidad: su valor proviene de cómo se recopila, organiza y actualiza la información, no de una promesa hecha por un solo vendedor.',
  'home.whatP3': 'Una hoja típica se organiza por categorías — zapatos, sudaderas, camisetas, chaquetas, pantalones, camisetas deportivas, accesorios y más — con columnas para nombres de productos, enlaces, tallas, referencias de vendedores, notas de QC y detalles de envío. Algunas versiones también incluyen información del almacén y consejos para leer las fotos de QC.',
  'home.whatNotice': 'Aviso de sitio independiente',
  'home.whatNoticeText': 'Este sitio web es un recurso informativo independiente. No está afiliado ni respaldado oficialmente por USFans, salvo que se indique explícitamente.',

  'home.benefitsTitle': '¿Por qué empezar con una hoja de cálculo?',
  'home.benefitsSub': 'Una hoja bien organizada convierte la investigación dispersa en un proceso claro y repetible.',
  'home.benefit1Title': 'Descubre más rápido',
  'home.benefit1Desc': 'Encuentra recursos de productos relevantes sin navegar por páginas dispersas.',
  'home.benefit2Title': 'Compara mejor',
  'home.benefit2Desc': 'Compara categorías, información de productos y notas una al lado de la otra.',
  'home.benefit3Title': 'Revisa el QC con cuidado',
  'home.benefit3Desc': 'Entiende qué buscar antes del envío internacional.',
  'home.benefit4Title': 'Investiga con confianza',
  'home.benefit4Desc': 'Aprende sobre envío, procesos de almacén, seguridad y errores comunes.',
  'home.benefitCta': 'Explorar USFans Spreadsheet',

  'home.checklistTitle': 'Lista de verificación de investigación de USFans Spreadsheet',
  'home.checklistSub': 'Una referencia rápida sobre qué comprobar antes de dar el siguiente paso.',
  'home.checkArea': 'Área de investigación',
  'home.checkWhat': 'Qué comprobar',
  'home.checkWhy': 'Por qué importa',
  'home.check.r1.area': 'Producto',
  'home.check.r1.what': 'Precio, vendedor, categoría',
  'home.check.r1.why': 'Evita malas elecciones',
  'home.check.r2.area': 'QC',
  'home.check.r2.what': 'Fotos, detalles, defectos',
  'home.check.r2.why': 'Detecta problemas pronto',
  'home.check.r3.area': 'Almacén',
  'home.check.r3.what': 'Almacenamiento, inspección',
  'home.check.r3.why': 'Entiende el estado del pedido',
  'home.check.r4.area': 'Envío',
  'home.check.r4.what': 'Peso, volumen, ruta',
  'home.check.r4.why': 'Estima el coste total',
  'home.check.r5.area': 'Vendedor',
  'home.check.r5.what': 'Historial, opiniones',
  'home.check.r5.why': 'Reduce la incertidumbre',
  'home.check.r6.area': 'Seguridad',
  'home.check.r6.what': 'Enlaces, pago, privacidad',
  'home.check.r6.why': 'Evita actividad sospechosa',

  'home.guidesTitle': 'Investiga USFans con confianza',
  'home.guidesSub': 'Empieza con nuestras guías y luego explora los temas que te interesan.',
  'home.guide.review.title': 'Reseña de USFans',
  'home.guide.review.desc': 'Entiende la plataforma, el flujo de trabajo, sus puntos fuertes y posibles riesgos.',
  'home.guide.shipping.title': 'Coste de envío',
  'home.guide.shipping.desc': 'Aprende qué puede afectar a los costes de envío internacional.',
  'home.guide.safety.title': 'Guía de seguridad',
  'home.guide.safety.desc': 'Entiende los riesgos comunes y prácticas de investigación más seguras.',
  'home.guide.article.title': 'Guía completa para principiantes',
  'home.guide.article.desc': 'Nuestra guía original y en profundidad sobre USFans Spreadsheet.',

  'home.faqTitle': 'FAQ de USFans Spreadsheet',
  'home.faqSub': 'Respuestas a las preguntas más frecuentes.',
  'home.faq.q1': '¿Qué es USFans Spreadsheet?',
  'home.faq.a1': 'Es un recurso de investigación compartido que se usa para organizar enlaces de productos, categorías, notas de vendedores, detalles de QC y referencias de compra en un solo lugar.',
  'home.faq.q2': '¿Cómo uso USFans Spreadsheet?',
  'home.faq.a2': 'Navega por categorías, revisa las notas de productos y QC, compara opciones y usa los enlaces para continuar tu investigación antes de hacer un pedido.',
  'home.faq.q3': '¿Es legítimo USFans?',
  'home.faq.a3': 'Mantenemos una postura neutral. Revisa el historial del vendedor, lee las opiniones y verifica los enlaces y páginas de pago antes de confiar en cualquier afirmación.',
  'home.faq.q4': '¿Es seguro USFans?',
  'home.faq.a4': 'La seguridad depende de lo cuidadoso que seas al investigar. Evita compartir contraseñas o datos sensibles y verifica cada enlace antes de hacer clic.',
  'home.faq.q5': '¿Cuánto cuesta el envío de USFans?',
  'home.faq.a5': 'Los costes varían según el peso, el volumen, la ruta y el destino. Usa estimaciones en lugar de precios fijos y confirma antes de pedir.',
  'home.faq.q6': '¿USFans tiene cupones?',
  'home.faq.a6': 'Las ofertas cambian con frecuencia. Revisa siempre la oferta oficial actual antes de usar cualquier cupón o código de descuento.',
  'home.faq.q7': '¿Qué es el almacén de USFans?',
  'home.faq.a7': 'Se refiere a servicios de almacenamiento e inspección que pueden usarse para guardar, revisar y consolidar artículos antes del envío.',
  'home.faq.q8': '¿Cómo funciona el QC de USFans?',
  'home.faq.a8': 'Las fotos y notas de QC te ayudan a detectar defectos, tallas incorrectas o artículos dañados antes de que se envíen internacionalmente.',

  'home.finalTitle': '¿Listo para explorar USFans Spreadsheet?',
  'home.finalText': 'Usa nuestras guías, comparaciones y recursos de investigación para facilitar el proceso, entender los riesgos y encontrar la información que necesitas antes de dar el siguiente paso.',
  'home.finalCta': 'Comprar ahora',
  'home.finalSecondary': 'USFans Spreadsheet',

  'home.articlesTitle': 'Últimas guías y artículos de USFans',
  'home.articlesSub': 'Artículos originales y detallados para ayudarte a investigar mejor.',
};